import type { GridColDef } from '@mui/x-data-grid';

import { useNavigate } from 'react-router';

import Link from '@mui/material/Link';
import { DataGrid } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography';

import { paths } from 'src/routes/paths';

import { useCombos } from 'src/api/hooks/useEmployerDataQueries';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

export function ComboList() {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useCombos();

  const combos = data?.data ?? [];

  const columns: GridColDef[] = [
    {
      field: 'comboLink',
      headerName: 'Combo name',
      flex: 1,
      renderCell: (params) => (
        <Link
          component="button"
          variant="body2"
          onClick={() =>
            navigate(`${paths.dashboard.employer_data.combo}/${params.row.comboId}`)
          }
        >
          {`${params.row.primaryName} (${params.row.comboId})`}
        </Link>
      ),
    },
  ];

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isError) {
    return (
      <Typography color="error" data-testid="combos-error" sx={{ mt: 2 }}>
        Unable to load combos. Please try again later.
      </Typography>
    );
  }

  return (
    <>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Combos
      </Typography>
      <DataGrid
        rows={combos}
        columns={columns}
        getRowId={(row) => row.comboId}
        disableRowSelectionOnClick
        disableColumnMenu
        disableColumnFilter
        disableColumnSelector
        disableColumnSorting
        showToolbar={false}
        autoHeight
      />
    </>
  );
}
